<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            v-if="listaGeral.length > 0 && alterado == true"
            color="success"
            type="gradient"
            class="d-inline"
            >Salvar Alterações</vs-button
          >
        </div>
      </div>
      <table
        v-if="listaGeral.length > 0"
        class="simpleTablePrincipal"
        width="100%"
      >
        <tr>
          <th>Tipo</th>
          <th width="40%">Interno</th>
          <th width="30%">Externo</th>
        </tr>
        <tr v-for="item in listaGeral" :key="item.ida">
          <td>{{ item.tipo }}</td>
          <td>{{ item.label }}</td>
          <td>
            <vs-select
              @change="seleciona(item)"
              v-model="item.valorExterno"
              class="select-large w-full"
            >
              <vs-select-item value="" text="Selecione" />
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.label"
                v-for="(item, index) in filtraRespostas(item.tipo)"
              />
            </vs-select>
          </td>
        </tr>
      </table>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            v-if="listaGeral.length > 0 && alterado == true"
            color="success"
            type="gradient"
            class="d-inline"
            >Salvar Alterações</vs-button
          >
        </div>
      </div>
    </form>

    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';

export default {
  props: {
    objUpdate: {
      type: Object,
    },
    objGeral: {
      type: Object,
    },
  },
  watch: {
    objUpdate(value) {
      this.preencheForm();
    },
  },
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      languages: lang,
      funcoesValicao: null,
      alterado: false,
      listaGeral: [],
      tiposBeneficios: [],
      formCadastro: { dados: {} },
    };
  },
  methods: {
    seleciona(item) {
      this.alterado = true;
    },
    filtraRespostas(tipo) {
      if (!this.objUpdate) return [];
      else {
        var list = this.objUpdate.listaExterno.filter((x) => x.tipo == tipo);
        return list;
      }
    },
    preencheForm() {
      this.listaGeral = [];
      if (this.objUpdate)
        this.objUpdate.listaInterno.forEach((element) => {
          // busca na lista
          var aux = this.objUpdate.listaDePara.find(
            (x) => x.tipo == element.tipo && x.valorInterno == element.id,
          );
          if (aux) {
            element.valorExterno = aux.valorExterno;
            element.idEmpresaFornecedorDePara = aux.idEmpresaFornecedorDePara;
          } else element.valorExterno = null;
          element.valorInterno = element.id;
          this.listaGeral.push(element);
        });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    onSubmit() {
      this.aguardeCadastro = true;
      this.$vs.loading();
      var objSend = {};
      objSend.listaGeral = this.listaGeral;
      objSend.idEmpresa = this.objGeral.idEmpresa;
      objSend.idFornecedor = this.objGeral.id_fornecedor;

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service
            .post('integracoes', 'salvarDePara', objSend)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },

    resetForm() {
      this.formCadastro = {
        dados: {},
      };
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
  },
  mounted() {
    this.preencheForm();
    //this.buscaDadosSelects("domMunicipio", "cidades", "nomeCidade", "idCidade");
    this.$validator.localize('ptBr', locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    'v-select': vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
<style lang="scss">
.simpleTablePrincipal {
  tr:nth-child(odd) {
    background-color: #fff;
    td {
      padding: 3px 5px;
    }
  }
  tr:nth-child(even) {
    background-color: #e7e7e7;
    td {
      padding: 3px 5px;

      .v-select {
        background-color: #fff;
      }
    }
  }
}
</style>
